import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  clientId: Yup.string()
    .nullable()
    .required('ADMINISTRATOR_VIEW.SANTANDER_CLABES.CLIENT_REQUIRED')
});

export default validationSchema;
